export default __webpack_public_path__ + "static/media/project2-DJI_0435.5726933d.jpg";